<template>
  <div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>

    <PageNotFound v-if="showPageNotFound"></PageNotFound>

    <div v-else>
      <div class="tw-name-bar">
        <span>สารป้องกันกําจัดโรคพืช</span>
      </div>

      <!-- Product hero section -->
      <img v-if="carousels.length > 0" :src="carousels[0].image" />

      <!-- Product name bar -->
      <div class="tw-name-bar">
        <span>{{ product.name }}</span>
      </div>

      <!-- Product details -->
      <div class="tw-details-section">
        <div v-html="productDetail" class="whitespace-pre-line" :style="{ marginBottom: `${marginBottom}px` }"></div>
      </div>

      <!-- Bottom Sheet -->
      <BottomSheet ref="bottomSheet" :product="product" :questionTitle="questionTitle" :useId="useId"
        :qrcodeScanId="qrCodeScan.id" :code="code" :showQuestion="product.showQuestion && !isPopupMessageModalActive"
        :company="company" />
    </div>

    <!-- Within limit dialog (badge) -->
    <b-modal v-model="isPopupMessageModalActive" :width="300">
      <img src="../../assets/thepwatana-guarantee.png" class="tw-guarantee-img" />
    </b-modal>

    <!-- Over limit dialog -->
    <b-modal v-model="isPopupWarningMessageModalActive" :width="300">
      <img src="../../assets/thepwatana-warning.png" class="tw-warning-img" />
    </b-modal>
  </div>
</template>

<script>
import "vue-popperjs/dist/vue-popper.css";
import PageNotFound from "../PageNotFound";
import BottomSheet from "../BottomSheet.vue";
import { nextTick } from "process";

export default {
  components: {
    PageNotFound,
    BottomSheet,
  },
  data() {
    return {
      carousels: [],
      latitude: "",
      longitude: "",
      product: {},
      showPageNotFound: false,
      isLoading: false,
      isPopupMessageModalActive: false,
      isPopupWarningMessageModalActive: false,
      useId: null,
      qrCode: {},
      productDetail: "",
      scanLogs: [],
      qrCodeScan: {},
      questionTitle: null,
      marginBottom: 0,
      company: {},
      nonce: null,
      isLog: false,
    };
  },
  computed: {
    code() {
      return this.$route.params.code;
    },
  },
  async mounted() {
    this.getLocation();
  },
  watch: {
    isPopupMessageModalActive(newValue) {
      if (!newValue) {
        if (this.product.showQuestion) {
          this.question();
        }
      }
    },
  },
  methods: {
    async checkNonce() {
      if (!this.nonce) {
        this.nonce = Math.random()
          .toString(36)
          .substring(2, 15);
      }

      const { statusCode } = await this.$axios.get(
        `/qrCode/${this.code}/nonce/${this.nonce}`
      );

      if (statusCode === 201) {
        this.isLog = true;
      } else {
        this.isLog = false;
      }
    },
    getDeviceId() {
      let id = localStorage.getItem("deviceId");
      if (!id) {
        id =
          (window.crypto && window.crypto.randomUUID
            ? window.crypto.randomUUID()
            : Date.now().toString(36) + Math.random().toString(36).slice(2));
        localStorage.setItem("deviceId", id);
      }
      return id;
    },
    async getLocation() {
      this.isLoading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );
      } else {
        await this.getProduct();
      }
    },
    async showPosition(position) {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.getProduct();
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
        case error.POSITION_UNAVAILABLE:
        case error.TIMEOUT:
        case error.UNKNOWN_ERROR:
          this.getProduct();
          break;
      }
    },
    async getProduct() {
      try {
        await this.checkNonce();

        const { statusCode, data } = await this.$axios.get(
          `/scan/${this.code}?latitude=${this.latitude}&longtitude=${this.longitude}&isLog=${this.isLog}&nonce=${this.nonce}&deviceKey=${this.getDeviceId()}`
        );

        if (statusCode === 200) {
          this.product = data.qrCodeWithProduct.product;
          this.productDetail = this.product.detail;
          this.carousels = this.product.productImages;
          this.qrCode = data.qrCodeWithProduct;
          this.scanLogs = data.scanLogs;
          this.qrCodeScan = data.qrCodeScan;

          this.getCompany();

          if (!this.isEmpty(data.question)) {
            this.useId = data.question.questionaireUseId;
            this.getQuestion();
          } else {
            this.product.showQuestion = false;
          }

          if (this.scanLogs.length > this.product.qrScanLimit) {
            this.isPopupMessageModalActive = false;
            this.product.showQuestion = false;
            this.isPopupWarningMessageModalActive = true;
          } else {
            this.isPopupMessageModalActive = true;
          }
        } else if (
          statusCode === 404 ||
          statusCode === 400 ||
          statusCode === 500
        ) {
          this.showPageNotFound = true;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;

        nextTick(() => {
          setTimeout(() => {
            if (this.$refs.bottomSheet) {
              this.marginBottom = this.$refs.bottomSheet.$el.clientHeight;
            }
          }, 500);
        });
      }
    },
    async getCompany() {
      const { statusCode, data } = await this.$axios.get(
        `/crm/code/${this.code}/company`
      );

      if (statusCode === 200) {
        this.company = data;
        document.documentElement.style.setProperty(
          "--color-primary",
          this.company.color
        );
      }
    },
    async getQuestion() {
      const { statusCode, data } = await this.$axios.get(
        `/question/use/${this.useId}`
      );

      if (statusCode === 200) {
        this.questionTitle = data.name;
      }
    },
    isEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    question() {
      this.$router.push(
        `/${this.code}/company/${this.product.companyId}/brand/${this.product.brandId}/product/${this.product.id}/questionnaire/${this.useId}/${this.qrCodeScan.id}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.tw-hero-section {
  position: relative;
  height: 330px;
  background: linear-gradient(135deg, #d4e5f0 0%, #e8eef5 30%, #c5d8e8 60%, #b0c8dc 100%);
  overflow: hidden;
}

.tw-hero-badge {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  object-fit: cover;
  z-index: 2;
}

.tw-hero-rotated-name {
  position: absolute;
  left: -20px;
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
  transform-origin: center center;
  font-size: 43px;
  font-weight: 700;
  font-style: italic;
  color: rgba(224, 232, 245, 0.6);
  white-space: nowrap;
  z-index: 1;
  text-transform: uppercase;
}

.tw-hero-product-img {
  position: absolute;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
  max-height: 85%;
  max-width: 40%;
  object-fit: contain;
  z-index: 2;
}

.tw-name-bar {
  background: linear-gradient(to right, #00b7f1, #20429c);
  padding: 8px 18px;

  span {
    color: white;
    font-size: 22px;
    font-weight: 600;
  }
}

.tw-details-section {
  padding: 16px 18px;
  color: #58595b;
  font-size: 13px;
}
</style>
